const defaultOptGroup = {
  "group": "Default",
  "options": [
    {
      "label": "All events",
      "value": "All events"
    }
  ]
};

const audienceTypeOptGroup = {
  "group": "Audience",
  "options": [
    {
      "label": "For members",
      "value": "For members"
    },
    {
      "label": "For kids",
      "value": "For kids"
    },
    {
      "label": "For teens",
      "value": "For teens"
    },
    {
      "label": "For visitors 65 and over",
      "value": "For visitors 65 and over"
    },
    {
      "label": "For educators",
      "value": "For educators"
    },
    {
      "label": "For visitors with disabilities",
      "value": "For visitors with disabilities"
    }
  ]
};

const happeningTypeOptGroup = {
  "group": "Event",
  "options": [
    {
      "label": "Films",
      "value": "Films"
    },
    {
      "label": "Performances",
      "value": "Performances"
    },
    {
      "label": "Gallery experiences",
      "value": "Gallery experiences"
    },
    {
      "label": "Classes",
      "value": "Classes"
    },
    {
      "label": "Workshops",
      "value": "Workshops"
    },
    {
      "label": "Lectures/panels",
      "value": "Lectures/panels"
    },
    {
      "label": "Music",
      "value": "Music"
    },
    {
      "label": "Parties",
      "value": "Parties"
    },
    {
      "label": "Store events",
      "value": "Store events"
    }
  ]
};

export const optionGroups = [defaultOptGroup, audienceTypeOptGroup, happeningTypeOptGroup];
